export class HUD {
  private container: HTMLDivElement;
  private el: HTMLDivElement;
  private toggleBtn: HTMLButtonElement;
  private isVisible = true;
  private isCollapsed = false;

  constructor(mount: HTMLElement) {
    this.container = document.createElement('div');
    this.container.style.position = 'absolute';
    this.container.style.left = '12px';
    this.container.style.top = '12px';
    this.container.style.zIndex = '3';

    this.toggleBtn = document.createElement('button');
    this.toggleBtn.innerHTML = '📊';
    this.toggleBtn.style.position = 'absolute';
    this.toggleBtn.style.right = '4px';
    this.toggleBtn.style.top = '4px';
    this.toggleBtn.style.width = '24px';
    this.toggleBtn.style.height = '24px';
    this.toggleBtn.style.border = 'none';
    this.toggleBtn.style.borderRadius = '4px';
    this.toggleBtn.style.background = 'rgba(255,255,255,0.2)';
    this.toggleBtn.style.cursor = 'pointer';
    this.toggleBtn.style.fontSize = '14px';
    this.toggleBtn.style.padding = '0';
    this.toggleBtn.style.pointerEvents = 'auto';
    this.toggleBtn.style.zIndex = '5';
    this.toggleBtn.title = 'Debug-Panel ein/ausklappen';
    this.toggleBtn.onclick = () => this.toggle();

    this.el = document.createElement('div');
    this.el.style.position = 'relative';
    this.el.style.padding = '10px 34px 10px 12px';
    this.el.style.background = 'rgba(0,0,0,0.65)';
    this.el.style.border = '1px solid rgba(255,255,255,0.15)';
    this.el.style.borderRadius = '10px';
    this.el.style.color = 'rgba(255,255,255,0.9)';
    this.el.style.fontSize = '12px';
    this.el.style.lineHeight = '1.5';
    this.el.style.userSelect = 'none';
    this.el.style.pointerEvents = 'none';
    this.el.style.whiteSpace = 'pre';
    this.el.textContent = 'Loading...';

    this.container.appendChild(this.el);
    this.container.appendChild(this.toggleBtn);
    mount.appendChild(this.container);
  }

  private toggle() {
    this.isCollapsed = !this.isCollapsed;
    if (this.isCollapsed) {
      this.el.style.display = 'none';
      this.toggleBtn.innerHTML = '📈';
    } else {
      this.el.style.display = 'block';
      this.toggleBtn.innerHTML = '📊';
    }
  }

  setText(text: string) {
    this.el.textContent = text;
  }

  setVisible(visible: boolean) {
    if (this.isVisible === visible) return;
    this.isVisible = visible;
    this.container.style.display = visible ? 'block' : 'none';
  }

  dispose() {
    this.container.remove();
  }
}
